import CollapseHierarchy from './CollapseHierarchy'
export default CollapseHierarchy
